<template>
  <div style="height: 96vh;width: 94vw">

    <el-container class="contain-6" style="padding: 10px 10px">


      <el-drawer
          :title="titleProm"
          :visible.sync="dialogTableVisible2"
          :modal="false"
          direction="rtl"
          size="80%">
        <iframe frameborder="0" style="width:100%; height:900px;" :src="srcProm"></iframe>

      </el-drawer>
      <div class="bbb">
        <div v-show="echartShow" style="display: flex">
          <div ref="chart" style="width: 800px; height: 250px;"></div>
          <div ref="chart2" style="width: 800px; height: 250px;"></div>

        </div>
        <!-- 添加显示/隐藏开关和Bl组件 -->
        <div>
          <div style="margin: 10px 0;">
            <el-switch
                v-model="showBlChart"
                active-text="显示图表"
                inactive-text="隐藏图表"
                :width="60">
            </el-switch>
          </div>
          <Bl v-if="showBlChart" :chartData="myChartData" />
        </div>
        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">广告ID:</span>
          <el-input v-model="valueProm" placeholder="请输入广告ID" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>
          <span class="style-title">投手:</span>
          <el-input v-model="person" placeholder="请输入投手" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>

          <span class="style-title">时间:</span>
          <el-date-picker
              v-model="value1"
              type="datetime"
              style="margin-left: 5px;margin-top: 4px;width: 200px;align-items: center;display: flex"
              value-format="yyyy-MM-dd HH:00:00"
              size="mini" clearable
              placeholder="选择日期时间">
          </el-date-picker>
          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>


          <div style="margin-left: 6px;height: 30px;margin-top:10px;color: black">
            <el-switch
                v-model="echartShow"
                :width="35"
            >
            </el-switch>
          </div>
          <el-button
              size="mini"
              style="margin-left: 6px;height:30px;margin-top:8px"
              @click="showColumnSetting = true">
            字段设置
          </el-button>

          <el-dialog
              title="字段设置"
              :visible.sync="showColumnSetting"
              width="35%">
            <el-checkbox-group v-model="colOptions">
              <el-checkbox
                  v-for="col in columnOptions"
                  :key="col.prop"
                  :label="col.prop">
                {{ col.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-dialog>

<!--          <el-checkbox-->
<!--              v-model="showT"-->
<!--              style="margin-top: 11px"-->
<!--          >显示T-->
<!--          </el-checkbox>-->
        </el-header>
        <el-table
            v-loading="loading"
            ref="tableData1"
            :data="tableData"
            stripe
            border

            max-height="79vh"
            height="79vh"
            style="margin-top: 11px;width: 98%"
            @cell-dblclick="rowClickEvent"
            @cell-click="contextClick"
            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
            size="mini"
            highlight-current-row
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            row-key="id"
            lazy
            @sort-change="sortMethod"
            :load="load"
        >


          <el-table-column
              prop="gameName"
              label="游戏名"
              v-if="colOptions.includes('gameName')"
              min-width="180"
              show-tooltip-when-overflow
          >
            <template slot-scope="{row}">

              <span class="promotion">{{ row.gameName }}</span>
            </template>

          </el-table-column>

          <el-table-column
              prop="statHour"
              label="时间"
              v-if="colOptions.includes('statHour')"
              min-width="60"

          >
            <template slot-scope="{row}">

              <span style="color: #3a8ee6">{{
                  row.statHour == null ? '-' : row.statHour.split(':')[0] + ":" + row.statHour.split(':')[1]
                }}</span>
            </template>

          </el-table-column>

          <el-table-column
              prop="accountId"
              label="账户id"
              min-width="160"
              v-if="colOptions.includes('promotionId')"
          >
            <template slot-scope="{row}">

              <span class="promotion">{{ row.accountId }}</span>

            </template>

          </el-table-column>
          <el-table-column
              prop="promotionId"
              label="广告id"
              min-width="160"
              v-if="colOptions.includes('promotionId')"
          >
            <template slot-scope="{row}">

              <span class="promotion">{{ row.promotionId }}</span>

            </template>

          </el-table-column>

          <el-table-column
              prop="materialId"
              label="素材id"
              min-width="160"
              v-if="colOptions.includes('materialId')"
          >
            <template v-slot="scope">

              <span class="promotion">{{ scope.row.materialId }}</span>

            </template>

          </el-table-column>

          <el-table-column

              prop="click"
              label="操作"
              v-if="colOptions.includes('click')"
              min-width="80"

          >
            <template slot-scope="{row}">
              <el-button size="mini" @click="jump(row)">跳转</el-button>
            </template>
          </el-table-column>
          <el-table-column
              prop="tfPerson"
              label="投放人员"
              v-if="colOptions.includes('tfPerson')"


          >

          </el-table-column>


          <el-table-column
              prop="statCost"
              label="消耗(3分钟)"
              min-width="110"
              sortable
              v-if="colOptions.includes('statCost')"
          >


          </el-table-column>
          <el-table-column
              prop="ljBl"
              label="环比前一日"
              min-width="90"
              :formatter="value_format"

              v-if="colOptions.includes('ljBl')"
          >

          </el-table-column>
          <el-table-column
              prop="sumRoi"
              label="ROI(3分钟)"
              min-width="111"
              sortable
              v-if="colOptions.includes('sumRoi')"
          >

          </el-table-column>
          <el-table-column
              prop="statCostY"
              label="环比前一日"
              min-width="90"
              :formatter="value_format"

              v-if="colOptions.includes('statCostY')"
          >
          </el-table-column>

          <el-table-column
              prop="f1HAmount"
              label="时速"

              v-if="colOptions.includes('f1HAmount')"
          >
            <template slot-scope="{row}">

              {{ (row.f1HAmount * 20).toFixed(1) }}

            </template>

          </el-table-column>

          <el-table-column
              prop="getType"
              label="方式"
              min-width="55"
              v-if="colOptions.includes('getType')"
          >

          </el-table-column>
          <el-table-column
              prop="getPrice"
              label="出价"
              min-width="60"
              v-if="colOptions.includes('getPrice')"
          >
            <template slot-scope="{row}">

              <span v-if="row.getType==='RU'">{{ row.getPrice / 100 }}</span>

              <span v-else>{{ row.getPrice }}</span>

            </template>


          </el-table-column>

          <el-table-column
              prop="getPrice"
              label="出价达成率"
              min-width="100"
              v-if="colOptions.includes('getPrice')"
          >
            <template slot-scope="{row}">
              <span v-if="row.getType==='RU'">{{ (row.today24Roi / row.getPrice * 100)|dataFilters2 }}</span>
              <span v-else style="color: #8c939d">非ROI出价</span>
            </template>


          </el-table-column>
          <el-table-column
              label="ROI判断（预估）"
              align="center"

          >

            <el-table-column
                prop="today24Roi"
                label="今日素材预估24小时ROI（此点消耗）"

                :formatter="value_format"
                v-if="colOptions.includes('today24Roi')"
            >

            </el-table-column>

            <el-table-column
                prop="compare3"
                label="精确对比"

                :formatter="value_format"

                v-if="colOptions.includes('compare3')"
            >
              <template slot-scope="{row}">

                <span v-if="row.compare3>0" style="color: #d65055">{{ row.compare3|dataFilters2 }}</span>

                <span v-else style="color: #5daf34">{{ row.compare3|dataFilters2 }} </span>

              </template>
            </el-table-column>
            <el-table-column
                prop="yesterday24Roi"
                label="昨日素材预估24小时ROI（此点消耗）"

                :formatter="value_format"
                v-if="colOptions.includes('yesterday24Roi')"
            >

            </el-table-column>


            <el-table-column
                prop="today24RoiGame"
                label="今日游戏预估24小时ROI（此点消耗）"

                :formatter="value_format"

                v-if="colOptions.includes('today24RoiGame')"
            >

            </el-table-column>


            <el-table-column
                prop="yesterday24RoiGame"
                label="昨日游戏预估24小时ROI（此点消耗）"

                :formatter="value_format"

                v-if="colOptions.includes('yesterday24RoiGame')"
            >
            </el-table-column>


            <el-table-column
                prop="seven24RoiNow"
                label="前七日游戏实际24小时ROI（此点消耗）"

                :formatter="value_format"

                v-if="colOptions.includes('seven24RoiNow')"
            >
            </el-table-column>
          </el-table-column>
          <!--          倍率预估-->
          <el-table-column
              label="倍率判断(预估)"
              align="center"
          >

            <el-table-column
                prop="today24Bl"
                label="今日素材预估24小时倍率（此点消耗）"

                v-if="colOptions.includes('today24Bl')"
            >

            </el-table-column>


            <el-table-column
                prop="compare1"
                label="精确对比"

                :formatter="value_format"

                v-if="colOptions.includes('compare1')"
            >
              <template slot-scope="{row}">

                <span v-if="row.compare1>0" style="color: #d65055">{{ row.compare1|dataFilters2 }}</span>

                <span v-else style="color: #5daf34">{{ row.compare1|dataFilters2 }} </span>

              </template>
            </el-table-column>
            <el-table-column
                prop="yesterday24Bl"
                label="昨日素材预估24小时倍率（此点消耗）"

                v-if="colOptions.includes('yesterday24Bl')"
            >

            </el-table-column>
            <el-table-column
                prop="today24BlGame"
                label="今日游戏预估24小时倍率（此点消耗）"

                v-if="colOptions.includes('today24BlGame')"

            ></el-table-column>
            <el-table-column
                prop="yesterday24BlGame"
                label="昨日游戏预估24小时倍率（此点消耗）"


                v-if="colOptions.includes('yesterday24BlGame')"
            >
            </el-table-column>

            <el-table-column
                prop="seven24BlNow"
                label="前七日游戏实际24小时倍率（此点消耗）"

                v-if="colOptions.includes('seven24BlNow')"
            >

            </el-table-column>

          </el-table-column>
          <!--          ROI准确-->
          <el-table-column
              label="ROI判断（准确）"
              align="center"
          >
            <el-table-column
                prop="yesterdayRoiYg"
                label="昨日素材预估24小时ROI（24小时消耗）"

                :formatter="value_format"
                v-if="colOptions.includes('yesterdayRoiYg')"
            >

            </el-table-column>
            <el-table-column
                prop="compare4"
                label="精确对比"

                v-if="colOptions.includes('compare4')"
            >

              <template slot-scope="{row}">

                <span v-if="row.compare4>0" style="color: #d65055">{{ row.compare4|dataFilters2 }}</span>

                <span v-else style="color: #5daf34">{{ row.compare4|dataFilters2 }} </span>

              </template>

            </el-table-column>
            <el-table-column
                prop="yg24GameRoi"
                label="昨日游戏预估24小时ROI（24小时消耗）"

                :formatter="value_format"
                v-if="colOptions.includes('yg24GameRoi')"
            >

            </el-table-column>
            <el-table-column
                prop="seven24Roi"
                label="前七日游戏实际24小时ROI"

                :formatter="value_format"

                v-if="colOptions.includes('seven24Roi')"
            >

            </el-table-column>

          </el-table-column>
          <!--      倍率准确-->
          <el-table-column
              align="center"
              label="倍率判断（准确）">

            <el-table-column
                prop="yesterdayBlYg"
                label="昨日素材预估24小时倍率（24小时消耗）"

                v-if="colOptions.includes('yesterdayBlYg')"
            >

            </el-table-column>
            <el-table-column
                prop="compare2"
                label="精确对比"
                :formatter="value_format"

                v-if="colOptions.includes('compare2')"
            >
              <template slot-scope="{row}">

                <span v-if="row.compare2>0" style="color: #d65055">{{ row.compare2|dataFilters2 }}</span>

                <span v-else style="color: #5daf34">{{ row.compare2|dataFilters2 }} </span>

              </template>
            </el-table-column>

            <el-table-column
                prop="yg24GameBl"
                label="昨日游戏预估24小时倍率(24小时消耗)"

                v-if="colOptions.includes('yg24GameBl')"
            >

            </el-table-column>
            <el-table-column
                prop="seven24Bl"
                label="前七日游戏实际24小时倍率(24小时消耗)"
                v-if="colOptions.includes('seven24Bl')"
            >

            </el-table-column>

          </el-table-column>


        </el-table>

        <div class="block">

          <el-pagination
              @current-change="search(true)"
              :current-page.sync="currentPage"
              :page-sizes="[25]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="size">
          </el-pagination>
        </div>
      </div>

      <el-dialog :visible.sync="dialogTableVisible" width="78%"
                 :title="title"
      >
        <el-table :data="gridData"
                  max-height="75vh"
                  height="74vh"
                  size="mini"
                  stripe
        >
          <el-table-column property="dateHour" label="时间点" sortable width="200" align="center">
          </el-table-column>
          <el-table-column property="hourDelay" label="经过小时" sortable width="110" align="center"></el-table-column>
          <el-table-column property="sevenBl" label="7日(游戏维度)倍率" width="180" align="center"></el-table-column>
          <el-table-column property="nowBl" label="该时间段倍率" width="180" align="center"></el-table-column>
          <el-table-column property="upBl" label="提升比例" width="180" align="center">

            <template slot-scope="{row}">
              <span style="color: #d65055"
                    v-if="row.upBl/row.incomeRatio>0"> {{ row.upBl / row.incomeRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>{{ row.upBl / row.incomeRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="sevenRoi" label="7日(游戏维度)ROI" width="180" align="center"></el-table-column>
          <el-table-column property="nowRoi" label="该时间ROI" width="150" align="center"></el-table-column>
          <el-table-column property="upRoi" label="提升比例" width="150" align="center">
            <template slot-scope="{row}">

              <span style="color: #d65055"
                    v-if="row.upRoi/row.statCostRatio>0">  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="statCost" label="消耗" sortable width="100" align="center"></el-table-column>
          <el-table-column property="statCostRatio" label="消耗占比" width="150" align="center">

          </el-table-column>
          <el-table-column property="firstHourIncome" label="首小时收入" sortable width="150"
                           align="center"></el-table-column>
          <el-table-column property="incomeRatio" label="收入占比" width="150" align="center">

          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog :visible.sync="dialogTableVisible3" width="78%"
                 :title="title"
      >

        <div ref="lineChart" style="width: 100%; height: 400px; margin-bottom: 20px"></div>

        <el-table :data="tableHour"
                  max-height="75vh"
                  height="74vh"
                  size="mini"
                  stripe
        >

          <el-table-column property="dateDelay" label="经过小时" sortable width="110" align="center"></el-table-column>
          <el-table-column property="statCost" label="素材消耗" width="180" align="center"></el-table-column>
          <el-table-column property="statAttributionMicroGame24HAmount" label="收入" width="180" align="center"></el-table-column>
          <el-table-column property="costRatio" label="消耗占比" width="180" align="center"></el-table-column>
          <el-table-column property="dailyTotalCost" label="当日总消耗" width="180" align="center"></el-table-column>
          <el-table-column property="dailyTotalCost" label="ROI" width="180" align="center">
            <template slot-scope="{row}">
              {{(row.statAttributionMicroGame24HAmount/row.statCost*100).toFixed(2)+'%'}}

            </template>

          </el-table-column>

        </el-table>


      </el-dialog>
    </el-container>

  </div>
</template>

<script>

import Bl from './Bl.vue';
export default {
  name: "GameBroad",
  components: {
    Bl
  },
  data() {

    return {
      valueProm: '',
      showBlChart:false,
      showT: true,
      dialogTableVisible3: false,
      showColumnSetting: false,
      columnOptions: [
        {prop: 'gameName', label: '游戏名'},
        {prop: 'statHour', label: '时间'},
        {prop: 'promotionId', label: '广告ID'},
        {prop: 'materialId', label: '素材ID'},
        {prop: 'click', label: '操作'},
        {prop: 'tfPerson', label: '投放人员'},
        {prop: 'statCost', label: '消耗'},
        {prop: 'ljBl', label: '环比前一日(消耗)'},
        {prop: 'sumRoi', label: 'ROI'},
        {prop: 'statCostY', label: '环比前一日(ROI)'},
        {prop: 'f1HAmount', label: '时速'},
        {prop: 'getType', label: '投放方式'},
        {prop: 'getPrice', label: '出价'},
        {prop: 'today24Roi', label: '今日素材预估24小时ROI（此点消耗）'},
        {prop: 'compare3', label: '精确对比'},
        {prop: 'yesterday24Roi', label: '昨日素材预估24小时ROI（此点消耗）'},
        {prop: 'today24RoiGame', label: '今日游戏预估24小时ROI（此点消耗）'},
        {prop: 'yesterday24RoiGame', label: '昨日游戏预估24小时ROI（此点消耗）'},
        {prop: 'seven24RoiNow', label: '前七日游戏实际24小时ROI(此点消耗)'},
        {prop: 'today24Bl', label: '今日素材预估24小时倍率(此点消耗)'},
        {prop: 'compare1', label: '精确对比'},
        {prop: 'yesterday24Bl', label: '昨日素材预估24小时倍率（此点消耗）'},
        {prop: 'today24BlGame', label: '今日游戏预估24小时倍率(此点消耗)'},
        {prop: 'yesterday24BlGame', label: '昨日游戏预估24小时倍率(此点消耗)'},
        {prop: 'seven24BlNow', label: '前七日游戏实际24小时倍率(此点消耗)'},
        {prop: 'yesterdayRoiYg', label: '昨日素材预估24小时ROI（24小时消耗）'},
        {prop: 'compare4', label: '精确对比'},
        {prop: 'yg24GameRoi', label: '昨日游戏预估24小时ROI（24小时消耗）'},
        {prop: 'seven24Roi', label: '前七日游戏实际24小时ROI'},
        {prop: 'yesterdayBlYg', label: '昨日素材预估24小时倍率（24小时消耗）'},
        {prop: 'compare2', label: '精确对比'},
        {prop: 'yg24GameBl', label: '昨日游戏预估24小时倍率(24小时消耗)'},
        {prop: 'seven24Bl', label: '前七日游戏实际24小时倍率(24小时消耗)'}



        // 添加所有需要控制的列配置...
      ],
      colOptions: ['gameName', 'statHour', 'promotionId', 'promotionId', 'materialId',
        'click', 'tfPerson', 'statCost', 'ljBl', 'sumRoi', 'statCostY', 'f1HAmount', 'getType',
        'getPrice', 'today24Roi', 'compare3', 'yesterday24Roi', 'today24RoiGame',
        'yesterday24RoiGame', 'seven24RoiNow', 'today24Bl', 'compare1', 'yesterday24Bl', 'today24BlGame', 'yesterday24BlGame', 'seven24BlNow'
        , 'yesterdayRoiYg', 'compare4', 'yg24GameRoi', 'seven24Roi', 'yesterdayBlYg', 'compare2', 'yg24GameBl', 'seven24Bl'], // 默认显示的列
      title: "",
      gridData: [],
      dialogTableVisible: false,
      size: 1,
      isSort: true,
      echartShow: false,
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],

      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      srcProm: '',
      titleProm: "",
      value1: '',
      currentPage: 1,
      loading: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      value: 0,

      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      height: 800,
      dialogTableVisible2: false,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: [],
      person: "",
      maxHeight: 800,
      selectedField: 'statCost',
      selectedField2: 'statCost',
      selectText: "",
      chartData: [], // 这里放入你的原始数据
      chartData2: [],
      chartInstance: null,
      chartInstance2: null,
      chartInstance3: null,
      tableHour: [],
      myChartData:  [
         ],

    }


  }, watch: {
    colOptions: {
      handler(newVal) {
        localStorage.setItem('columnSettings', JSON.stringify(newVal));
      },
      deep: true
    }

  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = (value * 100).toFixed(2) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
    if (this.chartInstance2) {
      this.chartInstance2.dispose()
    }
    if (this.chartInstance3) {
      this.chartInstance3.dispose()
    }
  }, created() {
    // 从localStorage加载保存的列设置
    const savedColumns = localStorage.getItem('columnSettings');
    this.colOptions = savedColumns ? JSON.parse(savedColumns) :
        this.columnOptions.map(col => col.prop);
  },
  methods: {


    sortMethod(column, prop, order) {

      console.log(column.order)
      console.log(column.prop)
      this.$axios
          .post('/tf1/data/find', {

            gameName: this.valueGame,
            person: this.person == null ? "" : this.person,
            currentPage: this.currentPage,
            uploadTime: this.value1,
            prop: column.prop,
            order: column.order,
            promId: this.valueProm == null ? "" : this.valueProm,
            type: this.showT ? 1 : 0

          })
          .then(successResponse => {
            this.tableData = successResponse.data.data.data

            this.tableData.forEach(function (e) {

              e.hasChildren = true
            })

            this.size = successResponse.data.data.size
            console.log(this.tableData)


            this.loading = false
            this.$nextTick(() => {
              this.$refs.tableData1.doLayout();
            });
          })

    },

    initChart() {
      this.echartShow = true
      this.chartInstance = this.$echarts.init(this.$refs.chart)
      this.updateChart()

    },
    initChart2() {
      this.echartShow = true

      this.chartInstance2 = this.$echarts.init(this.$refs.chart2)

      this.updateChart2()
    },   initChart3() {

      this.chartInstance3 = this.$echarts.init(this.$refs.lineChart)

      this.updateChart3()
    },
    updateChart() {
      const xData = this.chartData.map(item =>
          item.uploadTime.split(' ')[1].substring(0, 5) // 提取时间 HH:mm
      )

      const yData = this.chartData.map(item => item[this.selectedField])

      const option = {
        title: {
          text: '数据趋势分析' + this.selectText
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData.reverse(),
          name: '时间'
        },
        yAxis: {
          type: 'value',
          name: this.selectedLabel
        },
        series: [{
          data: yData.reverse(),
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: 'rgba(58,77,233,0.8)'},
              {offset: 1, color: 'rgba(58,77,233,0.3)'}
            ])
          }
        }]
      }

      this.chartInstance.setOption(option)

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance.resize()
      })
    },
    updateChart2() {
      const xData = this.chartData2.map(item =>
          item.statHour.substring(0, 5)  // 提取时间 HH:mm
      )

      const yData = this.chartData2.map(item => item[this.selectedField2])

      const option = {
        title: {
          text: '时间段趋势分析' + this.selectText
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData,
          name: '时间'
        },
        yAxis: {
          type: 'value',
          name: this.selectedLabel
        },
        series: [{
          data: yData,
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: 'rgba(58,77,233,0.8)'},
              {offset: 1, color: 'rgba(58,77,233,0.3)'}
            ])
          }
        }]
      }

      this.chartInstance2.setOption(option)

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance2.resize()
      })
    },
    updateChart3(){

      // 销毁旧的图表实例
      if (this.chartInstance3) {
        this.chartInstance3.dispose()
      }

      // 获取基准值（dateDelay=1时的值）
      const baseValue = this.tableHour.find(item => item.dateDelay === 1)
          ?.statAttributionMicroGame24HAmount || 1

      // 处理图表数据
      const xData = []
      const yData = []
      this.tableHour.forEach(item => {
        xData.push(item.dateDelay)
        yData.push((item.statAttributionMicroGame24HAmount / baseValue).toFixed(2))
      })

      // 初始化图表
      this.chartInstance3 = this.$echarts.init(this.$refs.lineChart)
      const option = {
        title: {
          text: '倍率变化趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          name: '经过小时',
          data: xData
        },
        yAxis: {
          type: 'value',
          name: '收入比值'
        },
        series: [{
          data: yData,
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#409EFF',
            width: 2
          },
          itemStyle: {
            color: '#409EFF',

          },   // 新增标签配置
          label: {
            show: true,          // 显示标签
            position: 'top',     // 标签位置（可选值：top/right/left/bottom）
            color: '#666',       // 文字颜色
            fontSize: 12,        // 文字大小
            formatter: (params) => {
              // 自定义格式：显示两位小数 + 百分比符号
              return `${(params.value * 1).toFixed(2)}倍`
            }
          }
        }],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        }
      }
      this.chartInstance3.setOption(option)


    },

    // 单机
    contextClick(row, column, cell, event) {

      this.selectText = "（广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId + "）"

      if (column.property === 'statHour') {

        if (row.statHour !== undefined) {

          this.$axios
              .get('/tf1/data/findHourMaterial?materialId=' + row.materialId
                  + '&promotionId=' + row.promotionId +
                  '&hour=' +this.value1.split(' ')[0]+' '+row.statHour.substring(0, 5), {})
              .then(successResponse => {

                this.tableHour = successResponse.data.data

                this.dialogTableVisible3 = true

                // 新增：在下一个tick初始化图表
                this.$nextTick(() => {
                  this.updateChart3()
                })
              })

        }else {


          this.$axios
              .get('/tf1/data/findHourMaterialAll?materialId=' + row.materialId
                  + '&promotionId=' + row.promotionId +
                  '&hour=' +this.value1, {})
              .then(successResponse => {
              this.myChartData=successResponse.data.data||[]
              console.log(successResponse.data.data)

              })
        }

      }

      console.log(column)

      if (column.property !== 'promotionId' && column.property !== 'materialId' && column.property !== 'tfPerson' && column.property !== 'statHour'
          && column.property !== 'statCostY'
          && column.property !== 'getPrice'
          && column.property !== 'getType'
          && column.property !== 'ljBl'
          && column.property !== 'sumIncome'
          && column.property !== 'f1HAmount') {

        if (column.property !== 'gameName' && column.property !== 'tfPerson' && column.property !== 'click') {
          this.$axios
              .get('/tf1/data/findDetail?promotionId=' + row.promotionId + '&materialId=' + row.materialId
                  + '&type=' + (this.showT?1:0), {})
              .then(successResponse => {

                console.log(successResponse.data.data)


                this.selectedField = column.property

                this.selectedLabel = column.label

                this.chartData = successResponse.data.data
                this.initChart()


              })

          this.$axios
              .get('/tf1/data/findDetailHour?materialId=' + row.materialId +

                  '&promotionId=' + row.promotionId + '&uploadTime=' + this.value1, {})

              .then(successResponse => {

                this.selectedField2 = column.property

                this.selectedLabel = column.label

                this.chartData2 = successResponse.data.data

                if (this.selectedLabel !== 'ROI(3分钟)')

                  this.initChart2()

              })


        } else if (column.property === 'gameName') {

          window.open("https://business.oceanengine.com/site/account-manage/ad/bidding/superior/promotion?keyword=[%22" + row.gameName + "%22]&searchType=[9]")

        }


      } else if (column.property === 'promotionId') {

        // window.open("https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=" + row.accountId + "&filter_keyword=%2522" + row.promotionId + "%2522&filter_search_type=%25229%2522" +
        //  "#?drawer_type=ad&drawer_tab=detail&drawer_target_id=" + row.promotionId)

        this.dialogTableVisible2 = true

        this.titleProm = row.gameName + "（广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId + "）"
        this.srcProm = "https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=" + row.accountId + "&filter_keyword=%2522" + row.promotionId + "%2522&filter_search_type=%25229%2522" +
            "#?drawer_type=ad&drawer_tab=detail&drawer_target_id=" + row.promotionId + "&a=" + Math.random()

      } else if (column.property === 'materialId') {

        // window.open("https://business.oceanengine.com/site/account-manage/ad/bidding/superior/promotion?keyword=[%22" + row.promotionId + "%22]&searchType=[-1]")
        window.open("https://ad.oceanengine.com/material_center/analysis/video/" + row.materialId + "?aadvid=" + row.accountId)

      }
      if (column.property === 'tfPerson') {
        this.title = "广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId


        this.$axios
            .get('/tf1/data/find4?promotionId=' + row.promotionId + '&materialId=' + row.materialId + '&uploadTime=' + this.value1, {})
            .then(successResponse => {
              this.gridData = successResponse.data.data

              this.dialogTableVisible = true


            })

      }

    },
    jump(row) {


      window.open("https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=" + row.accountId + "&filter_keyword=%2522" + row.promotionId + "%2522&filter_search_type=%25229%2522" +
          "#?drawer_type=ad&drawer_tab=detail&drawer_target_id=" + row.promotionId)


    },
    // 双击
    rowClickEvent(row, column, cell, event) {
      console.log(column)
      if (column.property === 'promotionId') {

        // window.open("https://business.oceanengine.com/site/account-manage/ad/bidding/superior/promotion?keyword=[%22" + row.promotionId + "%22]&searchType=[-1]")
        window.open("https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=" + row.accountId + "&filter_keyword=%2522" + row.promotionId + "%2522&filter_search_type=%25229%2522" +
            "#?drawer_type=ad&drawer_tab=detail&drawer_target_id=" + row.promotionId)


      }

    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },

    up(e) {

      if (e == 0) {

        if (this.currentPage > 1)
          this.currentPage--
        this.searchPage()

      } else {

        this.currentPage++

        this.searchPage()
      }


    }, clickTo(row) {

      console.log(row)

    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = value.toFixed(2)

      }
    },
    value_format(row, column, value) {

      console.log(value)
      // 截取当前数据到小数点后两位
      if (value === 0 || isNaN(value) || value * 100 === 0) {

        return "-"
      } else {
        value = (value * 100).toFixed(1) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },date_hour() {

      this.$axios
          .get('/tf1/data/findMaxUploadTime', {



          })
          .then(successResponse => {
            this.value1 = successResponse.data.data
          })
      // 格式化为 "yyyy-MM-dd HH:00:00"

    },

    search(flag) {

      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("Game3", JSON.stringify({name: this.valueGame, date: this.value1}))

      } else {

        if (localStorage.getItem("Game3") != null) {

          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("Game3")).name

          // this.value1 = JSON.parse(localStorage.getItem("Game3")).date


        }
      }

      this.maxHeight = window.innerHeight - 250;

      if (this.value1 != '') {

        this.loading = true

        this.$axios
            .post('/tf1/data/find', {

              gameName: this.valueGame,
              person: this.person == null ? "" : this.person,
              currentPage: this.currentPage,
              uploadTime: this.value1,
              prop: 'statCost',
              order: 'descending',
              promId: this.valueProm == null ? "" : this.valueProm,
              type: this.showT ? 1 : 0

            })
            .then(successResponse => {

              if(successResponse.data.code===200) {
                this.tableData = successResponse.data.data.data

                this.tableData.forEach(function (e) {

                  e.hasChildren = true
                })

                this.size = successResponse.data.data.size
                console.log(this.tableData)


                this.loading = false
                this.$nextTick(() => {
                  this.$refs.tableData1.doLayout();
                });

              }else{
                this.$message({
                  showClose: true,
                  message: successResponse.data.msg,
                  type: 'warning'
                });
                this.loading = false
              }
                })


      }

    }, load(tree, treeNode, resolve) {

      setTimeout(() => {

        console.log(tree.materialId)

        console.log(tree.promotionId)

        console.log(tree.uploadTime)

        this.$axios
            .get('/tf1/data/findDetailHour?materialId=' + tree.materialId +
                '&promotionId=' + tree.promotionId + '&uploadTime=' + tree.uploadTime + '&type=' + (this.showT ? 1 : 0), {})

            .then(successResponse => {

              resolve(successResponse.data.data)


            })
      }, 1000)
    }

  }
  ,
  updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  }
  ,
  mounted: function () {

    this.date_hour()
    this.height = window.innerHeight;
    this.maxHeight = window.innerHeight - 250;
    // this.date_format_new()


    this.findGame()
    this.search(false)
    for (let i = 0, len = 160; i <= 160; i++) {
      this.items.push(i + '')
    }
  }


}
</script>
<style>


.promotion:hover {
  cursor: pointer;
  color: #3a8ee6;
}

.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}


.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}


.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 93%;

  margin-top: 19px;

  display: flex;
  flex-direction: column;
}

.contain-6 {
  height: calc(100vh - 50px); /* 确保容器有明确的高度 */
  overflow-y: auto; /* 启用垂直滚动 */
}

.el-table {
  flex: 1; /* 让表格自动填充剩余空间 */
  min-height: 300px; /* 保证最小高度 */
}
</style>


<style scoped>
::v-deep .el-table .el-table__expanded-cell {
  background: #f8f9fa !important;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05); /* 可选添加内阴影增强效果 */
}

.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  max-height: 60vh;
  overflow-y: auto;
}

.el-checkbox {
  width: 280px;
  margin: 5px 10px;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>